import { useEffect, useState } from "react";
import { FileText, Video, Music, BookOpen, ListChecks, HandHeart } from "lucide-react";
import axios, { API } from "@/lib/api";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

const TYPE_ICON = { pdf: FileText, video: Video, audio: Music, article: BookOpen, checklist: ListChecks, prayer_guide: HandHeart };

export default function JamaahMateri() {
  const [materials, setMaterials] = useState(null);

  useEffect(() => {
    axios.get(`${API}/jamaah/materi`).then(({ data }) => setMaterials(data)).catch(() => setMaterials([]));
  }, []);

  if (materials === null) return <LoadingScreen />;

  return (
    <div data-testid="jamaah-materi-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Materi Pembelajaran</h1>
        <p className="text-sm text-[#64748B]">Akses materi pembekalan sebelum keberangkatan Anda.</p>
      </div>

      {materials.length === 0 ? (
        <EmptyState icon={BookOpen} title="Belum ada materi" description="Materi pembelajaran akan segera tersedia." />
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {materials.map((m) => {
            const Icon = TYPE_ICON[m.type] || FileText;
            return (
              <div key={m.id} data-testid={`jamaah-material-card-${m.id}`} className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#0F6B4F]/10 text-[#0F6B4F]"><Icon className="h-5 w-5" /></div>
                <p className="mt-3 font-medium text-[#1F2937]">{m.title}</p>
                <p className="mt-1 text-xs text-[#64748B]">{m.category}</p>
                <p className="mt-2 text-sm text-[#64748B]">{m.description}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
